export const HELP_URLS = {
  LANDING: '',

  MLB_STATS_API_PEOPLE:
    'https://docs.statsapi.mlb.com/reference#get-/api/v1/people/search',

  PROJECTOR: 'articles/10371395-projector-setup',

  PITCH_UPLOADER: 'articles/13567293-pitches#h_954d85de29',

  // when user data (e.g. pitch lists) need to be reassigned to other users/machines/teams
  PITCH_REASSIGN: 'articles/9096329-reassign-pitch-lists',

  PRODUCT_UPDATES: 'articles/11095947-trajekt-sports-product-updates',

  RAPSODO_HOW_TO: 'articles/8313059-rapsodo-setup',

  RAPSODO_PLATE_LOCATION: 'articles/11482279',

  /** troubleshooting Rapsodo error messages */
  RAPSODO_ERRORS: 'articles/8321528-rapsodo-errors',

  TRACKMAN_ERRORS: 'articles/9883089-trackman-errors',

  TRAINING: 'articles/8312721-training-pitches',

  SETTINGS: 'articles/9043471-use-settings-modal',

  SETTINGS_ACCESSORIES: 'articles/8813360-setting-up-and-using-your-foot-pedal',

  SETTINGS_CONTINUOUS_TRAINING: 'articles/9043427-how-to-continuous-training',

  USER_MANUAL: 'articles/9923231-trajekt-user-manual',
};

export const MISC_URLS = {
  /** what gets opened by demo toasts with links */
  TOAST_DEMO: 'https://random.org',

  ERROR_TYPE_REQUEST_CHANGE_FORM:
    'https://form.asana.com/?k=vCs2Zc_CWA8wlLu6I2zN5w&d=1132096673582797',
};

export const INTERCOM_ARTICLE_IDS = {
  MACHINE_DISCONNECTED: 8321311,
};
